import React from "react";
import { useTranslation } from "react-i18next";

const ContactUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="banner neumorphic-container rounded-0 p-5 mb-0">
      <div className="container col-lg-12">
        <h2 className="text-center">{t("contact.title")}</h2>
        <p className="text-center">{t("contact.subtitle")}</p>
      </div>
      <div className="neumorphic-container col-lg-6 p-5 mx-auto">
        <h3 className="text-center gradient-text w-100 mb-5">{t("contact.formTitle")}</h3>
        <form action="https://api.web3forms.com/submit" method="POST">
          <input type="hidden" name="access_key" value="abc"/>
          <div className="mb-4">
            <label htmlFor="name" className="form-label">{t("contact.nameLabel")}</label>
            <input name="name" type="text" className="form-control neumorphic-container rounded-3" id="name" aria-describedby="emailHelp"
                   placeholder={t("contact.namePlaceholder")}/>
          </div>
          <div className="mb-4">
            <label htmlFor="companyName" className="form-label">{t("contact.companyLabel")}</label>
            <input name="companyName" type="text" className="form-control neumorphic-container rounded-3" id="companyName"
                   aria-describedby="companyNameHelp"
                   placeholder={t("contact.companyPlaceholder")}/>
          </div>
          <div className="mb-4">
            <label htmlFor="email" className="form-label">{t("contact.emailLabel")}</label>
            <input name="email" type="email" className="form-control neumorphic-container rounded-3" id="messageTitle"
                   aria-describedby="messageTitleHelp"
                   placeholder={t("contact.emailPlaceholder")}/>
          </div>
          <div className="mb-5">
            <label htmlFor="message" className="form-label">{t("contact.messageLabel")}</label>
            <textarea name="message" className="form-control neumorphic-container rounded-3" id="message" aria-describedby="messageHelp"
                      placeholder={t("contact.messagePlaceholder")}></textarea>
          </div>
          <input type="hidden" name="botcheck" className="d-none"/>
          <button type="submit" className="button gradient px-5 py-2 rounded-5 w-100">{t("contact.submitButton")}</button>
        </form>
      </div>
    </section>
  );
}

export default ContactUs;
